import { IngestionScheduleItem } from 'Modules/Studio/components/IngestionOverrideForm/IngestionOverrideForm';
import Timezones from 'utils/Timezones/Timezones';

/**
 * @function getScheduleSummary
 * @description Generates a human-readable summary string from an IngestionScheduleItem object.
 * @param {IngestionScheduleItem} item - The schedule item object.
 * @returns {string} A descriptive summary of the schedule.
 */
export const getScheduleSummary = (item: IngestionScheduleItem): string => {
  let timeZoneDefaultValue = '';
  if (item.timezone) {
    const timeZones = Timezones.createTimezoneLookupMap(Timezones.getFullList);
    timeZoneDefaultValue = timeZones[item.timezone] || item.timezone;
  }

  switch (item.frequency) {
    case 'hourly': {
      const hours = Number(item.schedule);
      const hourText = hours === 1 ? 'hour' : 'hours';
      return `Running every ${hours} ${hourText}.`;
    }

    case 'daily': {
      return `Running daily at ${item.time} ${timeZoneDefaultValue}.`;
    }

    case 'weekly': {
      return `Running weekly on ${item.schedule} at ${item.time} ${timeZoneDefaultValue}.`;
    }

    default: {
      const exhaustiveCheck: never = item.frequency;
      return `Unknown schedule frequency: ${exhaustiveCheck}`;
    }
  }
};
